import { observer } from 'mobx-react';
import * as React from 'react';
import { component } from 'tsdi';
import { makeAutoObservable } from 'mobx';
import { injectTSDI } from '../../core/tsdi';
import { Markdown } from '../markdown';

import './aside.scss';

export const openAside = (title?: string, content?: string) => {
    const store = injectTSDI(AsideStore);
    store.open(title, content);
};

@component
class AsideStore {
    constructor() {
        makeAutoObservable(this);
    }

    public title?: string;

    public content?: string;

    public opened = false;

    public open = (title?: string, content?: string) => {
        this.opened = true;
        this.title = title;
        this.content = content;
    };

    public close = () => {
        this.opened = false;
    };
}

export const Aside = observer(() => {
    const { opened, close, title, content } = injectTSDI(AsideStore);

    return (
        <aside className={classnames('aside', { 'aside--active': opened })}>
            <div className="aside__close" onClick={close} />
            <h2 className="aside__heading">{title}</h2>
            <div className="aside__custom-content">
                <Markdown>{content}</Markdown>
            </div>
        </aside>
    );
});
